import { API_ROOT } from '../../config/config'
import { doGet, doPostDownload, doPut } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

const API_ROOT_VER = `${API_ROOT}/v1/accounting`

export const getStrategy = (projectCode) => {
  // /api/v1/accounting/strategy/{projectCode}
  const url = `${API_ROOT_VER}/strategy/${projectCode}`
  return doGet(url)
}

export const getStrategyToManageSub = (projectCode) => {
  // /api/v1/accounting/strategy/{projectCode}
  const url = `${API_ROOT_VER}/sub-strategy/${projectCode}`
  return doGet(url)
}

export const updateSubStrategy = (projectCode, request) => {
  // /api/v1/accounting/strategy/{projectCode}
  const url = `${API_ROOT_VER}/sub-strategy/${projectCode}`
  return doPut(url, request)
}

export const exportStrategy = (projectCode) => {
  // const API_ROOT_VER = 'http://localhost:80/api/v1/accounting'
  const url = `${API_ROOT_VER}/strategy/${projectCode}`
  return doPostDownload(url, {})
}
